import { useTheme } from "@mui/material/styles";


export default function Form({ sx, onSubmit, ...props }) {
	const theme = useTheme();
	const style = {
		root: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2)
		}
	};

	const submit = (e) => {
		e.preventDefault();
		onSubmit && onSubmit(e);
	};

	return <form {...props} onSubmit={submit} style={{ ...style.root, ...sx }} />;
}